import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAngularModule } from '../../modules/mat-angular.module';

export interface SentimentTrendsData {
  positive_aspects?: string[];
  negative_aspects?: string[];
  neutral_aspects?: string[];
}

@Component({
  selector: 'app-sentiment-trends',
  standalone: true,
  imports: [CommonModule, MatAngularModule],
  templateUrl: './sentiment-trends.component.html',
  styleUrl: './sentiment-trends.component.scss'
})
export class SentimentTrendsComponent {
  @Input() sentimentTrends: SentimentTrendsData | null = null;
  @Input() title: string = 'Sentiment Trends Analysis';
}
